import { writable } from "svelte/store";


const { subscribe, update } = writable({
	lang:localStorage.getItem("lang") || "ja",
	isReady:false
});

async function init(url){
	fetch(url)
		.then((res) => {
			return res.json();
		})
		.then((json) => {
			update((state) => {
				return {
					...state,
					...json,
					isReady:true
				};
			});
		})
		.catch((e) => {
			console.log("base error", e);
		});
}

export default {
	init,
	setLang:(lang) => {
		localStorage.setItem("lang", lang);
		update((state) => {
			return {
				...state,
				lang
			};
		});
	},
	subscribe
};
